var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-form-card',{attrs:{"header":"Settings","save-button-disabled":!_vm.settingsHaveChanged,"save-button-loading":_vm.isSubmitting},on:{"submit":_vm.onSubmit}},[_c('chain-form',{model:{value:(_vm.chainSettings),callback:function ($$v) {_vm.chainSettings=$$v},expression:"chainSettings"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }